import React from 'react'

import dogfood from "../images/Dog food.jpg";
import catfood from "../images/Cat food.jpg";
import health from "../images/Health Essentials.jpg";
import toys from "../images/Toys_new.jpg";

import litter from "../images/Litter.jpg";
import grooming from "../images/Grooming.jpg";
import bed from "../images/Beds.jpg";
import accessories from "../images/accessories.jpg";

import fashion_pet from "../images/Fashion.jpg";
import prescriptiondiet from "../images/diest.jpg";




function Products() {
    return (
        <div>


            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <a href='dog-food'>
                                            <div className="card">


                                                <img src={dogfood} className="card-img-top" alt="dogfood" />


                                                <center>
                                                    <a href='dog-food'>
                                                        <button style={{ margin: "2px" }} className='learn mb-3'>Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                        </svg></button>  </a>
                                                </center>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <a href='cat-food'>
                                            <div className="card">

                                                <img src={catfood} className="card-img-top" alt="catfood" />

                                                <center>
                                                    <a href='cat-food'>
                                                        <button style={{ margin: "2px" }} className='learn mb-3'>Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                        </svg></button>  </a>
                                                </center>
                                            </div>
                                        </a>
                                    </div>


                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <a href='healthproducts'>
                                            <div className="card">

                                                <img src={health} className="card-img-top" alt="health" />

                                                <center>
                                                    <a href='healthproducts'>
                                                        <button style={{ margin: "2px" }} className='learn mb-3'>Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                        </svg></button>  </a>
                                                </center>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <a href='toys'>
                                            <div className="card">

                                                <img src={toys} className="card-img-top" alt="toys" />

                                                <center>
                                                    <a href='toys'>
                                                        <button style={{ margin: "2px" }} className='learn mb-3'>Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                        </svg></button>  </a>
                                                </center>

                                            </div>
                                        </a>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <a href='litter'>
                                            <div className="card">


                                                <img src={litter} className="card-img-top" alt="litter" />


                                                <center>
                                                    <a href='litter'>
                                                        <button style={{ margin: "2px" }} className='learn mb-2 mt-2'>Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                        </svg></button>  </a>
                                                </center>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <a href='grooming'>
                                            <div className="card">

                                                <img src={grooming} className="card-img-top" alt="grooming" />


                                                <center>
                                                    <a href='grooming'>
                                                        <button style={{ margin: "2px" }} className='learn mb-2 mt-2'>Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                        </svg></button>  </a>
                                                </center>
                                            </div>
                                        </a>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">

                                            <img src={bed} className="card-img-top" alt="bed" />

                                            <center>
                                                <a href=''>
                                                    <button style={{ margin: "2px" }} className='learn mb-2 mt-2'>Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                    </svg></button>  </a>
                                            </center>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <a href='accessories'>
                                            <div className="card">

                                                <img src={accessories} className="card-img-top" alt="accessories" />

                                                <center>
                                                    <a href='accessories'>
                                                        <button style={{ margin: "2px" }} className='learn mb-2 mt-2'>Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                            <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                        </svg></button>  </a>
                                                </center>

                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <a href='fashion'>
                                        <div className="card">
                                            <img src={fashion_pet} className="card-img-top" alt="fashion_pet" />




                                            <center>
                                                <a href='fashion'>
                                                    <button style={{ margin: "2px" }} className='learn mb-3'>Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                    </svg></button>  </a>
                                            </center>
                                        </div>
                                        </a>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <a href='PrescriptionDiet'>
                                        <div className="card">

                                            <img src={prescriptiondiet} className="card-img-top" alt="prescriptiondiet" />

                                            <center>
                                                <a href='PrescriptionDiet'>
                                                    <button style={{ margin: "2px" }} className='learn mb-3'>Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                                                    </svg></button>  </a>
                                            </center>
                                        </div>
                                        </a>
                                    </div>

                                </div>

                            </div>
                        </div>


                    </div>
                </div>
            </div>

            <br />
        </div>
    )
}

export default Products